import React, { useMemo } from 'react';
import moment from 'moment';
import Clock from '../../../assets/svg/clock';
import Select from '../../../components/Select';
import { components } from 'react-select';
import './ScheduleModal.css';

const TimeInput = ({
  time,
  label,
  options,
  handleSelection,
  ...props
}) => {
  const selectedValue = useMemo(() => ({ label: moment(time).format('h:mm A'), value: time }), [time]);
  const dropdownOptions = useMemo(() => options.map(option => ({
    label: moment(option).format('h:mm A'),
    value: option
  })));

  return (
    <div className='flex-columns' style={{ marginTop: 16, minWidth: 128 }}>
      <Select
        label={label}
        placeholder='Select a time'
        options={dropdownOptions}
        value={selectedValue}
        components={{
          Control: ({ children, ...props }) => (
            <components.Control {...props}>
              <div style={{ marginLeft: 8 }}>
                <Clock fill='#B4B4C6' />
              </div>
              {children}
            </components.Control>
          )
        }}
        onChange={option => handleSelection(option.value)}
        {...props}
      />
    </div>
  );
};

export default TimeInput;
